"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggingHandler = void 0;
var axios_1 = __importDefault(require("axios"));
var __1 = require("..");
var logging_lookup_1 = require("../lookups/logging.lookup");
var LoggingHandler = /** @class */ (function () {
    function LoggingHandler() {
        this.config = {
            baseURL: "http://localhost:9108",
            headers: {
                'Content-Type': 'application/json',
            }
        };
    }
    LoggingHandler.prototype.log = function (exception, metaData, severity, type) {
        if (severity === void 0) { severity = __1.SeverityType.medium; }
        if (type === void 0) { type = logging_lookup_1.LoggingTypeLookUp.error; }
        this.config.baseURL = this.getServiceBaseUrl();
        var model = {
            client: window.location.href,
            type: type,
            severity: severity,
            exception: exception,
            metaData: metaData ? metaData : null
        };
        return axios_1.default.post('/log', model, this.config);
    };
    LoggingHandler.prototype.getServiceBaseUrl = function () {
        if (window.location.href.includes("localhost")) {
            return "http://localhost:9108";
        }
        else if (window.location.href.includes("dev-")) {
            return "https://logging.e-microsvc.mytelnet.co.za";
        }
        else {
            return "https://logging.e-microsvc.mytelnet.co.za";
        }
    };
    return LoggingHandler;
}());
exports.LoggingHandler = LoggingHandler;
//# sourceMappingURL=logging.handler.js.map